<template>
  <div class="accountPopup" v-show="isVisible">
    <!-- <datastoping ref="stop" />
    <datamonitor ref="monit" />
    <!-- 回跳到公众号详情弹窗 -->
    <official-account-popup
      :isVisible="isVisible2"
      :loadingVisible="loadingVisible2"
      :data="officialDetailData"
      :pagingData="pagingData"
      v-if="isDetailsShow"
      @closeClick="closeClick2"
    ></official-account-popup>
    <!-- 数据监控弹窗 -->
    <monitor-popup
      :monitorVisible="monitorVisible"
      @monitorCloseClick="monitorCloseClick"
    ></monitor-popup>
    <!-- 数据回采弹窗 -->
    <stoping-popup
      :stopingVisible="stopingVisible"
      @stopingCloseClick="stopingCloseClick"
    ></stoping-popup>
    <!-- 相似文章弹窗 -->
    <similar-articles-popup
      :similarData="similarDataObject"
      :loadingVisible="loadingVisible2"
      :similarVisible="similarVisible"
      @similarCloseClick="similarCloseClick"
      @lookDetails="lookDetails"
    ></similar-articles-popup>
    <!-- 投前分析 -->
    <analysis-popup
      :analysisData="analysisData"
      @analysisCloseClick="analysisCloseClick"
      :analysisVisible="analysisVisible"
    ></analysis-popup>
    <!-- 分组管理 -->
    <group-management
      style="margin-left: calc(110% / 2 - 540px / 2); margin-top: 180px"
      :managementVisible="managementVisible"
      :manageData="manageData"
      :handel="['添加收藏', '删除', '新建分组']"
      @closeManagementClick="closeManagementClick"
      @groupCallBack="groupCallBack"
    >
    </group-management>
    <div class="popup_box">
      <!-- 标签部分 -->
      <h1>公众号详情</h1>
      <span class="tanc" @click="tonewindow(data)">新窗口显示详情</span>
      <img :src="close" alt="关闭" @click="closeClick()" />
      <div class="detailOverFlow">
        <!-- {{data}} -->
        <div class="detail">
          <img :src="data.avatar" alt="data.name" />
          <div class="detail_center">
            <div class="detail_center_top">
              <el-tooltip
                class="item"
                effect="dark"
                :content="data.name"
                placement="top"
              >
                <span v-if="data.name">{{ data.name }}</span>
                <span v-else>{{ data.mp_name }}</span>
              </el-tooltip>
              <img
                :src="QRCode"
                @mouseenter="QRMouseenter()"
                @mouseleave="QRMouseleave()"
              />
              <div class="QR_box" v-show="QRVisible">
                <!-- {{data}} -->
                <img :src="data.qrcode" alt="二维码" />
              </div>
              <span class="detail_center_top_tijiao">
                <img :src="dataService2" alt="投前分析" />
                <span @click="analysisClick(data)"
                  >投前分析（{{ data.monitor_num }}）</span
                >
                <!-- <img :src="topti" alt="提交" /> -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="收藏"
                  placement="top"
                  v-if="data.is_favorite == 0"
                >
                  <img
                    :src="collection1"
                    alt="收藏"
                    @click="collectionClick(data)"
                  />
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="已收藏"
                  placement="top"
                  v-else-if="data.is_favorite == 1"
                >
                  <img
                    :src="isCollected"
                    alt="已收藏"
                    @click="cancelCollectionClick(data)"
                  />
                </el-tooltip>
              </span>
            </div>
            <span class="detail_center_center" v-if="data.wx"
              >微信ID：{{ data.wx }}</span
            >
            <span class="detail_center_center" v-else
              >微信ID：{{ data.wxid }}</span
            >
            <span class="detail_center_bottom" v-if="data.owner"
              >主体信息：{{ data.owner }}</span
            >
            <span class="detail_center_bottom" v-else
              >主体信息：{{ data.zhuti }}</span
            >
          </div>
          <div class="detail_right">
            <span>极致了指数<el-tooltip
                  class="item"
                  effect="dark"
                  placement="left"
                >
                <div slot="content" style="font-size:14px;float:right">极致了指数是系统基于公众号的文章数、传播指数、风险指数、<br>热点指数等数据分析得出的综合评分；指数越高标示账号质量越好。<br>极致了指数
              = (综合指数 * 100 / 月发文数) / 100</div>
                  <img
                    src="@/common/assets/tisi.png"
                    style="
                      width: 20px;
                      height: 20px;
                      display: inline-block;
                      margin-left: 10px;
                      vertical-align: middle;
                      cursor: pointer;
                    "
                  />
                  </el-tooltip></span>
            <span style="color: #febb02; font-size: 20px;       text-align: center;
            line-height: 50px;">{{
              data.dajiala_index
            }}</span>
          </div>
        </div>
        <div class="dec">简介：{{ data.desc }}</div>
        <div class="industry">
          <span>所属行业：{{ data.media }}</span
          ><span v-for="(item, index) in data.tag" :key="index"
            >标签：{{ item }}</span
          >
        </div>
        <div class="popup_class">
          <span>
            <img :src="collectTime" alt="收藏次数" />
            <span>{{ data.collect_count }}次收藏</span>
          </span>
          <span>
            <img :src="monitor" alt="收藏次数" /><span
              @click="monitorShow(data)"
              >监控下次发文</span
            >
          </span>
          <span
            ><img :src="stoping" alt="收藏次数" /><span
              @click="stopingShow(data)"
              >数据回采</span
            ></span
          >
          <span
            ><img :src="similar" alt="收藏次数" /><span
              @click="similarShow(data)"
              >相似公众号</span
            ></span
          >
        </div>
        <!-- 数据表 -->
        <div class="popup_page">
          <div class="popup_page_title">
            <span class="popupLeft">
              <span class="span span1"
                @click="popupClick('历史推文', 0)"
                :class="popupItem == 0 ? 'active_color' : ''"
              >
                <span class="span">历史推文</span>
              </span>
              <span class="span span1"
                @click="popupClick('基础分析', 1)"
                :class="popupItem == 1 ? 'active_color' : ''"
              >
                <span class="span">基础分析</span>
              </span>
              <span class="span span1"
                :class="popupItem == 2 ? 'active_color' : ''"
              >
                <span  @click="popupClick('主体信息', 2)" v-show="data.owner_total>=1">主体信息（<span style="color:red">{{data.owner_total}}</span>）</span>
                <span @click="popupClick('主体信息', 2)" v-show="data.owner_total==0">主体信息（<span style="color:red">1</span>）</span>
              </span>
              <span class="span span1"
                :class="popupItem == 3 ? 'active_color' : ''"
              >
                <span  @click="popupClick('原文链接', 3)" v-show="data.url_link_total>=1">原文链接(<span style="color:red">{{data.url_link_total}}</span>)</span>
                <span style="color:#999;cursor: default;" v-show="data.url_link_total==0">原文链接</span>
              </span>
              <span class="span span1"
                :class="popupItem == 4 ? 'active_color' : ''"
              >
                <span @click="popupClick('关联小程序', 4)" v-show="data.associated_applet_total>=1">关联小程序(<span style="color:red">{{data.associated_applet_total}}</span>)</span>
                <span style="color:#999;cursor: default;" v-show="data.associated_applet_total==0">关联小程序</span>
              </span>
            </span>
            <span class="popupRight">
              已采集发文次数：{{ data.mp_fetch_sum }}
            </span>
            <div class="rg_tab" @click="getinfoMethod" v-show="!showk">
            <img src="../../../static/images/update_img.png" alt="" class="update_img">
            <span style="margin-left:10px;font-size:0.7vw">数据更新时间：<span>{{timestr}}
              <el-tooltip
                  class="item"
                  effect="dark"
                  placement="left"
                >
                <div slot="content" style="font-size:14px">数据刷新点击间隔为5秒,文章较多的情况下数据更新会有3-5分钟延迟</div>
                  <img
                    src="@/common/assets/tisi.png"
                    style="
                      width: 20px;
                      height: 20px;
                      display: inline-block;
                      margin-top:10px;
                      vertical-align: middle;
                      margin-right:15px;
                      cursor: pointer;
                      float:right;
                    "
                  />
                  </el-tooltip>
            </span>
            </span>
            </div>
            <div class="rg_tabs1" v-show="showk">
            <img src="../../../static/images/update_img.png" alt="" class="update_img">
            <span style="margin-left:10px;font-size:0.7vw">数据更新中....</span>
            </div>
            <el-tooltip
                  class="item"
                  effect="dark"
                  placement="left"
                >
                <div slot="content" style="font-size:14px">数据刷新点击间隔为5秒,文章较多的情况下数据更新会有3-5分钟延迟</div>
                  </el-tooltip>
          </div>
          <!-- 下面内容部分 -->
          <!-- v-if="analysis_info.VIPLimit" -->
          <div class="popup_page_handle" v-show="popupItem == 0">
            <div class="popupTip">
              高级会员/豪华会员/超级会员 显示 近6/12/18个月文章
              <span style="font-size:12px;margin-left:15px">数据库数据量过大，正在优化，如果遇到问题，建议多刷新几次<el-tooltip
                  class="item"
                  effect="dark"
                  placement="left"
                >
                <div slot="content" style="font-size:14px">功能刚上线不久，历史文章数量可能不全，正在努力补充数据中，请耐心等待。</div>
                <img
                    src="@/common/assets/tisi.png"
                    style="
                      width: 15px;
                      height: 15px;
                      display: inline-block;
                      vertical-align: middle;
                      margin-left:15px;
                      cursor: pointer;
                    "
                  />
                  </el-tooltip></span>
            </div>
            <div class="popup_pageing">
              <!-- <span>数据统计规则</span> -->
            </div>
            <div class="popup_page_handlePaging">
              <!-- 只显示头条 -->
              <span class="valueTop">
                <!-- 只显示头条 -->
                <el-switch @change="isTop()" v-model="valueTop"></el-switch>
                <span>只显示头条</span>
              </span>
              <!-- 只显示爆文 -->
              <span class="valueExplosive">
                <el-switch @change="isExplosive()" v-model="valueExplosive">
                </el-switch>
                <span>只显示爆文</span>
              </span>
              <!-- 赛选时间 -->
              <span class="valueDate">
                <el-date-picker
                  v-model="valueDate"
                  @change="pageTimeChange(valueDate)"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                  <!-- :picker-options="pickerOptions" -->
                </el-date-picker>
              </span>
              <!-- 搜索 -->
              <el-select v-model="screen" placeholder="请选择" class="screenTit" @change="chscreen(screen)">
              <el-option
                v-for="item in screenTit"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              <span v-show="item.value==''">{{item.label}}</span>
               <el-tooltip
                  class="item"
                  effect="dark"
                  content="默认只搜索1/3数据，需要更完整数据请联系客服定制"
                  placement="left"
                >
                  <span v-show="item.value==2">{{item.label}}</span>
                 </el-tooltip>
              </el-option>
            </el-select>
              <span class="valueSearch">
                <input
                  type="text"
                :placeholder="placedata"
                  @keyup.enter="similarKeyUp($event)"
                  @keyup="similarSearchKw($event)"
                />
                <div @click="similarSearch()">
                  <img :src="searching" alt="搜索" /><span>搜索</span>
                </div>
              </span>
              <p class="hq">
                <span class="hqspan">获取公众号最新发文：<span class="sx">刷新数据</span></span>
              </p>
              <!-- 页面内容 -->
              <div class="paging">
                <div
                  v-for="(item, itemIndex) in pagingData.article_list"
                  :key="itemIndex"
                  @mouseenter="pagingMouseEnter(item, itemIndex)"
                  @mouseleave="pagingMouseLeave(item, itemIndex)"
                  v-show="loadingVisible"
                >
                  <div class="paging_title">
                    <span>
                      <span>发文时间：{{ item.postTime }}</span>
                      <span>更新时间：{{ item.articles[0].up_time }}</span>
                    </span>
                    <span>
                      <span>点赞相对质量值</span>
                      <span>阅读数相对质量值</span>
                      <span>阅读数</span>
                      <span>点赞数</span>
                      <span>在看数</span>
                      <span>关注数</span>
                    </span>
                  </div>
                  <div
                    class="paging_content"
                    v-for="(articles, favoriteIndex) in item.articles"
                    :key="favoriteIndex"
                  >
                    <span @click="openMethod(articles.href)">
                      <span class="sspp1">
                        <span class="sspp" :class="articles.tag==1?'spank1':''">{{ articles.position }}</span>
                         <span class="span1" v-show="articles.tag==1">原创</span>
                        </span>
                      <span>{{ articles.title }}</span>
                    </span>
                    <!-- 相对质量值：阅读数/公众号平均阅读数${articles.read} -->
                    <span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                      :content="contentname(articles.avg_zan)"
                        placement="top"
                      >
                        <span>
                          <img
                            src="@/common/assets/relative_mass.png"
                            style="
                              width: 18px;
                              display: inline-block;
                              height: 14px;
                              margin-left: -10px;
                              padding-right: 4px;
                            "
                          />
                          {{ articles.relative_zan }}
                        </span>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                          '相对质量值：阅读数/公众号平均阅读数' + articles.avg_read+' 数值越高,文章质量越高'
                        "
                        placement="top"
                      >
                        <span>
                          <img
                            src="@/common/assets/relative_mass.png"
                            style="
                              width: 18px;
                              display: inline-block;
                              height: 14px;
                              margin-left: -10px;
                              padding-right: 4px;
                            "
                          />
                          {{ articles.quality_num }}
                        </span>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="阅读数"
                        placement="top"
                      >
                        <span>
                          <img
                            src="@/common/assets/eye.png"
                            style="
                              width: 14px;
                              display: inline-block;
                              height: 10px;
                              margin-left: -10px;
                              padding-right: 4px;
                            "
                          />
                          {{ articles.read }}
                        </span>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="点赞数"
                        placement="top"
                      >
                        <span>
                          <img
                            src="@/common/assets/agree_with.png"
                            style="
                              width: 14px;
                              display: inline-block;
                              height: 14px;
                              margin-left: -10px;
                              padding-right: 4px;
                            "
                          />
                          {{ articles.zan }}
                        </span>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="在看数"
                        placement="top"
                      >
                        <span>
                          <img
                            src="@/common/assets/looking.png"
                            style="
                              width: 14px;
                              display: inline-block;
                              height: 14px;
                              margin-left: -10px;
                              padding-right: 4px;
                            "
                          />
                          {{ articles.looking }}
                        </span>
                      </el-tooltip>
                      <span
                        class="favorite"
                        @mouseenter="
                          articlesMouseEnter(articles, favoriteIndex)
                        "
                        @mouseleave="
                          articlesMouseLeave(articles, favoriteIndex)
                        "
                      >
                        <span
                          class="favorite_span"
                          v-if="articles.is_favorite == 0 || is_collect == true"
                          @click="collectedArrticle(articles)"
                          :class="
                            pagingNum == itemIndex &&
                            favoriteNum == favoriteIndex
                              ? 'favorite_active'
                              : ''
                          "
                        >
                          收藏
                        </span>
                        <span
                          class="favorite_span"
                          v-else-if="
                            articles.is_favorite == 1 || is_collect == false
                          "
                          @click="cancelCollectAtricle(articles)"
                          :class="
                            pagingNum == itemIndex &&
                            favoriteNum == favoriteIndex
                              ? 'favorite_active'
                              : ''
                          "
                        >
                          取消收藏
                        </span>
                        <img
                          src="@/common/assets/is_collect.png"
                          v-if="articles.is_favorite == 0"
                          style="
                            width: 14px;
                            display: inline-block;
                            height: 14px;
                            margin-left: -10px;
                            padding-right: 8px;
                          "
                        />
                        <img
                          src="@/common/assets/is_collected.png"
                          v-else-if="articles.is_favorite == 1"
                          style="
                            width: 14px;
                            display: inline-block;
                            height: 14px;
                            margin-left: -10px;
                            padding-right: 8px;
                          "
                        />{{ articles.favorite_count }}
                      </span>
                    </span>
                    <!-- 收藏文章分组组 -->
                    <div class="groupingBox" v-show="gzhaosc">
                      <div class="grouping">
                        <div class="group_top">
                          <p class="topTx">编辑分组</p>
                          <img
                            :src="close"
                            alt=""
                            class="close_img"
                            @click="ungroupShow1"
                          />
                        </div>
                        <div class="rollerBox">
                          <div
                            class="group"
                            v-for="(item, key, index) in groupList"
                            :key="index"
                          >
                            <el-radio v-model="groupid" :label="item.id">{{
                              item.name
                            }}</el-radio>
                            <div class="btns">
                              <div
                                class="delete_btn"
                                @click="deleteGroup(item.id)"
                              >
                                删除
                              </div>
                              <div
                                class="delete_btn"
                                @click="changeShowMethod11(item.id)"
                              >
                                更改
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="btn_box">
                          <div class="addbtn" @click="addShowMethod11">
                            新建分组
                          </div>
                          <div class="rgbtn">
                            <div class="close_btn" @click="ungroupShow1">
                              取消
                            </div>
                            <div
                              class="qr_btn"
                              @click="addArticleCollection(articles, groupid)"
                            >
                              确定
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 添加分组 -->
                    <div class="newGroupBack" v-show="addShow">
                      <div class="newGroup">
                        <div class="add_top">
                          <p class="titTx">添加新的分组</p>
                          <img
                            :src="close"
                            alt=""
                            class="close_img"
                            @click="addCloseMethod1"
                          />
                        </div>
                        <p class="tit">分组名称</p>
                        <input
                          type="text"
                          v-model="gzgroupName"
                          placeholder="请输入内容"
                          class="name_inp"
                        />
                        <div class="btn_box">
                          <div class="rgbtn">
                            <div class="close_btn" @click="addCloseMethod1">
                              取消
                            </div>
                            <div class="qr_btn" @click="addgroupMethods">
                              创建
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 更改组名 -->
                    <div class="newGroupBack" v-show="changeShow">
                      <div class="newGroup">
                        <div class="add_top">
                          <p class="titTx">更改分组</p>
                          <img
                            :src="close"
                            alt=""
                            class="close_img"
                            @click="changeCloseMethod"
                          />
                        </div>
                        <p class="tit">分组名称</p>
                        <input
                          type="text"
                          v-model="groupName2"
                          placeholder="请输入内容"
                          class="name_inp"
                        />
                        <div class="btn_box">
                          <div class="rgbtn">
                            <div class="close_btn" @click="changeCloseMethod">
                              取消
                            </div>
                            <div class="qr_btn" @click="changgroup()">确定</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-show="loadingVisible && pagingData.article_list.length == 0"
                  style="font-size: 18px; text-align: center; margin-top: 20px"
                >
                  暂无数据
                </div>
                <div
                  v-show="
                    !loadingVisible && pagingData.article_list.length != 0
                  "
                >
                  <img
                    :src="loading_img"
                    alt="动画"
                    style="width: 30%; margin-left: calc(100% / 2 - 30% / 2); margin-top: 10%;"
                  />
                </div>
              </div>
              <!-- {{data}} -->
              <!-- 会员等级不足提示问题 -->
              <!-- <div class="popup_page_handle" v-if="data.VIPLimit">
                <div class="popup_page_VIPLimit">
                  会员等级不足，<span @click="VIPLimit()" style="color: red"
                    >前往升级会员</span
                  >
                </div>
              </div> -->
              <!-- 底部分页按钮 -->
              <div class="paging_bottom">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :page-sizes="[20]"
                  :page-size="20"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="pagingData.total"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <div
            class="popup_page_handle"
            v-show="popupItem == 1"
            v-if="analysis_info.VIPLimit"
          >
            <div class="popup_page_detailStatistic">
              <span class="popup_page_detailStatistic_title">
                <span>预估粉丝活跃数</span>
                <span>近7天文章发布数</span>
                <span>近3次发文头条平均阅读数</span>
                <span>近3次发文次条平均阅读数</span>
                <span>近3次发文3～N条平均阅读数</span>
              </span>
              <span class="popup_page_detailStatistic_content">
                <span>{{ analysis_info.fans }}</span>
                <span>{{ analysis_info.articles }}</span>
                <span>{{ analysis_info.avg_top_read }}</span>
                <span>{{ analysis_info.avg_second_read }}</span>
                <span>{{ analysis_info.avg_other_read }}</span>
              </span>
            </div>
            <div class="popup_page_detailDetial">
              <div class="popup_page_detailDetial_left">
                <span class="detailDetial_left_title">阅读概述</span>
                <span class="detailDetial_left_top">
                  <span>位置</span>
                  <span>篇数</span>
                  <span>阅读平均</span>
                  <span>阅读最高</span>
                  <span>平均点赞</span>
                  <span>点赞最高</span>
                </span>
                <span
                  class="detailDetial_left_content"
                  v-for="(overviewItem, index) in analysis_info.read_overview"
                  :key="index"
                >
                  <span>{{ overviewItem.position }}</span>
                  <span>{{ overviewItem.article_num }}</span>
                  <span>{{ overviewItem.avg_read }}</span>
                  <span>{{ overviewItem.read_max }}</span>
                  <span>{{ overviewItem.avg_praise }}</span>
                  <span>{{ overviewItem.praise_max }}</span>
                </span>
              </div>
              <div class="popup_page_detailDetial_right">
                <img :src="analysis_info.avatar" alt="weix" />
                <span>扫一扫，关注它</span>
              </div>
            </div>
          </div>
          <div class="popup_page_handle" v-show="popupItem == 1" v-else>
            <div class="popup_page_VIPLimit">
              会员等级不足，<span @click="VIPLimit()" style="color: red"
                >前往升级会员</span
              >
            </div>
          </div>
          <div
            class="popup_page_handle"
            v-show="popupItem == 2"
            v-if="subject_info2.VIPLimit"
          >
            <div class="popup_subject_info">
              <!-- 公众号主体&运用地区 -->
              <div class="subject_title">
                <img :src="subject" alt="zhuti" />
                <span v-if="subject_info.owner">公众号主体：<span style="color:#666;font-size:14px">{{ subject_info.owner }}</span></span>
                <span v-else>公众号主体：<span style="color:#666;font-size:14px">{{ data.owner }}</span></span>
                <span>运营地区：{{ subject_info.area }}</span>
              </div>
              <!-- 共主体公众号 -->
              <div class="subject_content">
                <span class="subject_content_title" v-show="subject_info2.same_accounts.length>=4">
                  <img :src="subject" alt="zhuti" />
                  <span>同主体公众号：</span>
                  <el-tooltip
                class="item"
                effect="dark"
                content="点击查看更多同主体公众号"
                placement="top"
              >
              <span @click="subjectListClick()"
                    >同主体公众号数量（{{
                      subject_info2.same_accounts.length
                    }}）</span
                  >
              </el-tooltip>
                </span>
                <span class="subject_content_title" v-show="subject_info2.same_accounts.length<=3">
                  <img :src="subject" alt="zhuti" />
                  <span>同主体公众号：</span>
                  <el-tooltip
                class="item"
                effect="dark"
                content="同主体公众号已全部显示"
                placement="top"
              >
              <span
                    >同主体公众号共（{{
                      subject_info2.same_accounts.length
                    }}）个</span
                  >
              </el-tooltip>
                </span>
                <span
                  v-if="subject_info2.same_accounts.length != 0"
                  :class="subject1==true?'subject_content_list1':'subject_content_list'"
                >
                  <div
                    v-for="(accounts, index) in subject_info2.same_accounts"
                    :key="index"
                    class="subject_content_some"
                    @click="officialDetials(accounts, index)"
                  >
                    <span class="common_subject">
                      <img
                        :src="accounts.avatar"
                        alt="accounts.name"
                        class="common_subject_img"
                      />
                      <span class="common_subject_span1">
                        <span>{{ accounts.name }}</span
                        ><br />
                        <span>{{ accounts.wxid }}</span>
                      </span>
                      <span class="common_subject_img2">
                        <img
                          :src="collection1"
                          alt="收藏"
                          @click="collectionSubjectClick(accounts, index)"
                        />
                        <img :src="dataService2" alt="监控数据" />
                        <img :src="stoping" alt="数据回采" />
                        <img :src="similar" alt="相似文章" />
                      </span>
                    </span>
                    <span class="common_subject_handle"> </span>
                  </div>
                </span>
                <div class="subject_content_list" v-else>
                  <span
                    style="
                      font-size: 18px;
                      display: inline-block;
                      width: 100%;
                      text-align: center;
                      line-height: 170px;
                    "
                    >暂无同主体公众号</span
                  >
                </div>
              </div>
              <!-- 日常发文时段： -->
              <div class="chart_box">
                <p class="subject_content_title">
                  <img :src="subject" alt="" class="zhuti" />
                  <span>日常发文时段：</span>
                </p>
                <div class="chart">
                  <div
                    v-for="(it, index) in chartList"
                    class="numdata"
                    :key="index"
                  >
                    <p class="num" v-show="it.num > 0">{{ it.num }}</p>
                    <div
                      class="sj_z"
                      style="width: 2px"
                      :style="it.height"
                      :class="it.num > 0 ? 'num_act' : ''"
                    ></div>
                  </div>
                </div>
                <div class="chart_date">
                  <p
                    v-for="(i, index) in chartList"
                    class="number"
                    :key="index"
                  >
                    {{ index }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="popup_page_handle" v-show="popupItem == 2" v-else>
            <div class="popup_page_VIPLimit">
              主体信息功能仅限豪华及以上会员可看，<span @click="VIPLimit()" style="color: red"
                >前往升级会员</span
              >
            </div>
          </div>
          <div
            class="popup_page_handle"
            v-show="popupItem == 3"
            v-if="originHrefObject.VIPLimit"
          >
            <div class="popup_subject_info">
              <div class="popup_subject_infos">
                <span class="popup_subject_infos_title">时间区域选择：</span>
                <span class="popup_subject_infos_list">
                  <span
                    v-for="(titleSelectionList, index) in titleSelection"
                    :key="index"
                    @click="originClick(titleSelectionList, index)"
                    :class="
                      originHrefNUm == index ? 'popup_subject_infos_active' : ''
                    "
                  >
                    {{ titleSelectionList }}
                  </span>
                </span>
              </div>
              <div class="popup_subject_infos">
                <span class="popup_subject_infos_title">排序方式选择：</span>
                <span class="popup_subject_infos_list">
                  <span
                    v-for="(titleSortList, index) in titleSort"
                    :key="index"
                    @click="originClick2(titleSelectionList, index)"
                    :class="
                      originHrefNUm2 == index
                        ? 'popup_subject_infos_active'
                        : ''
                    "
                  >
                    {{ titleSortList }}
                  </span>
                </span>
              </div>
              <div class="popup_subject_originList">
                <div class="popup_subject_originTitle">
                  <span>文章</span>
                  <span>公众号名称</span>
                  <span>发布时间</span>
                  <span>阅读数</span>
                  <span>点赞数</span>
                  <span>原文链接</span>
                </div>
                <!-- originHrefObject -->
                <div
                  class="popup_subject_originSome"
                  v-show="!originHrefVisible"
                >
                  <img
                    :src="loading_img"
                    alt="loding……"
                    style="width: 30%; margin-left: calc(100% / 2 - 30% / 2); margin-top: 10%;"
                  />
                </div>
                <div
                  class="popup_subject_originSome"
                  v-show="originHrefVisible"
                  v-if="originHrefObject.article_list.length != 0"
                >
                  <div
                    v-for="(list, index) in originHrefObject.article_list"
                    :key="index"
                    class="popup_subject_originSomeSpan"
                  >
                    <span>
                      <span>{{ positionStatus(list.article_position) }}</span>
                      <span
                        style="cursor: pointer"
                        @click="opentitle(list.article_url)"
                        >{{ list.article_title }}</span
                      >
                    </span>
                    <span>{{ list.mp_name }}</span>
                    <span>{{ list.article_pubtime }}</span>
                    <span>{{ list.article_readnum }}</span>
                    <span>{{ list.article_zannum }}</span>
                    <span
                      ><a :href="list.original_address" style="text-decoration:none" target="_blank"
                        >原文链接</a
                      ></span
                    >
                  </div>
                </div>
                <div v-else>
                  <span
                    style="
                      width: 100%;
                      display: inline-block;
                      text-align: center;
                      height: 60px;
                      line-height: 60px;
                      font-size: 20px;
                    "
                    >暂无数据</span
                  >
                </div>
              </div>
            </div>
            <!-- 底部分页按钮 -->
            <div
              class="paging_bottom"
              v-show="originHrefObject.article_list.length != 0"
            >
              <el-pagination
                @current-change="handleCurrentChange2"
                :page-sizes="[10]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="originHrefObject.total_number"
              >
              </el-pagination>
            </div>
          </div>
          <div
            class="popup_page_handle"
            v-show="popupItem == 3"
            v-else-if="!data.VIPLimit"
          >
            <div class="popup_page_VIPLimit">
              会员等级不足，<span @click="VIPLimit()" style="color: red"
                >前往升级会员</span
              >
            </div>
          </div>
          <div class="popup_page_handle" v-show="popupItem == 3" v-else>
            <div class="popup_page_VIPLimit">
              会员等级不足，<span @click="VIPLimit()" style="color: red"
                >前往升级会员</span
              >
            </div>
          </div>
          <div
            class="popup_page_handle"
            v-show="popupItem == 4"
            v-if="appletData.VIPLimit"
          >
            <div class="popup_subject_info">
              <div class="popup_subject_relation">
                <span class="popup_subject_relation_title">排序方式选择：</span>
                <span class="popup_subject_relation_list">
                  <span
                    v-for="(relationItem, index) in relationSort"
                    :key="index"
                    @click="relationSortClick(relationItem, index)"
                    :class="
                      relationSortNum2 == index
                        ? 'popup_subject_infos_active2'
                        : ''
                    "
                  >
                    {{ relationItem }}
                  </span>
                </span>
              </div>
              <div
                class="popup_subject_applet_data"
                v-show="
                  appletData.applet_data.length != 0 &&
                  appletData.applet_data != undefined
                "
              >
                <div
                  class="popup_subject_applet_dataList"
                  v-for="(appletData, index) in appletData.applet_data"
                  :key="index"
                >
                  <div class="popup_subject_dataList_top">
                    <!-- <span class="popup_subject_dataList_topLeft"> -->
                    <img
                      :src="appletData.icon"
                      alt="appletData.title"
                      class="popup_subject_dataList_img"
                      v-if="appletData.icon"
                    />
                    <img
                      src="@/common/assets/commonPIC.png"
                      alt="appletData.title"
                      class="popup_subject_dataList_img"
                      v-else
                    />
                    <!-- </span> -->
                    <span class="popup_subject_dataList_topRight">
                      <span>
                        <span>{{ appletData.title }}</span>
                        <span>{{ appletData.appid }}</span>
                      </span>
                      <span>
                        <span>类目：{{ appletData.labels }}</span>
                        <span>AppId：{{ appletData.username }}</span>
                      </span>
                      <span>简介：{{ appletData.desc }}</span>
                    </span>
                  </div>
                  <div class="popup_subject_dataList_bottom">
                    <span>
                      <span>曝光量</span>
                      <span>{{ appletData.exposure_num }}</span>
                    </span>
                    <span>
                      <span>关联文章数</span>
                      <span>{{ appletData.article_num }}</span>
                    </span>
                    <span>
                      <span>关联公众号</span>
                      <span>{{ appletData.account_num }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-show="
                  appletData.applet_data.length == 0 &&
                  appletData.applet_data != undefined
                "
              >
                <span
                  style="
                    width: 100%;
                    display: inline-block;
                    text-align: center;
                    height: 60px;
                    line-height: 60px;
                    font-size: 20px;
                  "
                  >暂无数据
                </span>
              </div>
            </div>
          </div>
          <div class="popup_page_handle" v-show="popupItem == 4" v-else>
            <div class="popup_page_VIPLimit">
              会员等级不足，<span @click="VIPLimit()" style="color: red"
                >前往升级会员</span
              >
            </div>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import Vue from "vue";
// import datastoping from "@/pages/datastoping";
// import datamonitor from "@/pages/datamonitor";
export default {
  name: "officialAccount",
  data() {
    return {
      close: require("@/common/assets/close.png"),
      loading_img: require("@/common/assets/loding…….gif"),
      QRCode: require("@/common/assets/QRCode.png"),
      dataService2: require("@/common/assets/dataService2.png"),
      isCollected: require("@/common/assets/isCollected.png"),
      topti: require("@/common/assets/topti.png"),
      collection1: require("@/common/assets/collection1.png"),
      collectTime: require("@/common/assets/collectTime.png"),
      searching: require("@/common/assets/searching.png"),
      monitor: require("@/common/assets/monitor.png"),
      stoping: require("@/common/assets/stoping.png"),
      similar: require("@/common/assets/similar.png"),
      subject: require("@/common/assets/subject.png"),
      originHrefNUm: 3,
      originHrefNUm2: 0,
      popupTitle: [
        "历史推文",
        "基础分析",
        "主体信息",
        "原文链接",
        "关联小程序",
      ],
      titleSelection: ["1天", "7天", "30天", "60天"],
      titleSort: ["发布时间", "阅读数", "点赞数"],
      relationSort: ["曝光量", "涉及文章数", "涉及公众号数", "总阅读数"],
      valueTop: false,
      valueExplosive: false,
      valueDate: "",
      popupItem: 0,
      accessToken: "",
      currentPage4: 4,
      favoriteNum: -1,
      pagingNum: -1,
      analysis_info: {},
      subject_info: {},
      subject_info2: {}, 
      // 数据回采
      monitorVisible: false,
      stopingVisible: false,
      similarVisible: false,
      analysisVisible: false,
      originHrefVisible: false,
      managementVisible: false,
      similarData: {},
      analysisData: {},
      similarDataObject: {},
      top: 0, // 判断是否是头条
      is_hot: 0, // 判断是否爆文
      pageNum: 0,
      start_time: null, // 初始时间
      end_time: null, // 末始时间
      similarKw: "", // 搜索关键词
      manageData: {}, // 分组数据
      is_favorities: 0, // 是否被收藏
      loadingVisible2: false, // 相似文章动画判断
      subjectIndex: 0, // 通体公众号索引
      officialDetailData: {},
      isDetailsShow: false,
      isVisible2: false,
      chartList: [],
      originHrefObject: [],
      pageHref: 1,
      timeSortNum: 60,
      classSortNum: 1,
      appletData: {},
      relationSortNum: 0,
      relationSortNum2: 0,
      QRVisible: false,
      // 收藏分组
      gzhaosc: false,
      groupList: [],
      groupid: "",
      changeShow: false,
      addShow: false,
      groupName2: "",
      gzgroupName: "",
      articles_obj: {},
      // VIPLimit: false,
      is_collect: false,
      hrefs:'',
      timeshua:'',
      timestr:'',
      showk:false,
      t:5,
      inner:'',
      vip:'',
      subject1:false,
      screenTit: [{
        value: '',
        label: '标题搜索'
      }, {
        value: '2',
        label: '正文搜索'
      },],
      value: '',
      placedata:'请输入标题搜索',
      screen:'',
      time11:'',
    };
  },
  components: {
    // datastoping,
    // datamonitor,
    // monitorPopup,
    // stopingPopup,
    // similarArticlesPopup,
  },
  props: {
    // VIPLimit: {
    //   type: Boolean,
    //   default: true,
    // },
    isVisible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
    pagingData: {
      type: Object,
      default: () => {},
    },
    loadingVisible: {
      type: Boolean,
      default: false,
    },
    linkVar: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.NowTime1();
    // 保存taoken
    let info = JSON.parse(localStorage.getItem("userInfo"));
    if (info) {
      this.accessToken = info.accessToken;
      this.getinfoMethod();
    }
    // mp_detail借口
    this.$http.axiosFun(
      this.$api.search.mp_detail,
      {
        mId: this.data.mid,
      },
      (res) => {
        if (res.error_code == 0) {
          this.subject_info = {
            owner: res.data.owner,
            area: res.data.area,
          };
        }
      },
      {
        accessToken: this.accessToken,
      }
    );
    this.popupClick('历史推文', 0);
  },
  computed: {
    positionStatus() {
      return (position) => {
        switch (position) {
          case 1:
            return "头条";
          case 2:
            return "次条";
          case 3:
            return "三条";
          case 4:
            return "四条";
          case 5:
            return "五条";
          case 6:
            return "六条";
          case 7:
            return "七条";
          case 8:
            return "八条";
        }
      };
    },
    getquality_num() {
      return () => {};
    },
    contentname() {
      return (avg_zan) => {
        return `点赞相对质量值：点赞数/公众号平均点赞数 ${avg_zan}`;
      }
    }
  },
  methods: {
    getinfoMethod() {
            var that = this;
            that.$http.axiosFun(that.$api.user.user_profile, {}, function(res) {
                if (res.msg == 'success') {
                    that.vip = res.data.vip_id;
                }
            }, { 'Content-Type': 'application/x-www-form-urlencoded', 'accessToken': that.accessToken });
        },
    tonewindow(v){
      let routeUrl = this.$router.resolve({ path: './detail', query: { mid: v.mid, name: v.np_name, active: 0 } });
      window.open(routeUrl.href, '_blank');
    },
    chscreen(e){
      if(e==''){
        this.placedata = '请输入标题搜索'
      }else if(e==2){
        this.placedata = '请输入文章详情搜索'
      }
    this.screen = e;
    },
    // 查询VIP等级
    getinfoMethod() {
      var that = this;
      that.$http.axiosFun(that.$api.user.user_profile, {
      }, function (res) {
        if (res.msg == 'success') {
          that.vip = res.data.vip_id;
          that.getmpupdate();
        } else {
        }
      }, { 'Content-Type': 'application/x-www-form-urlencoded', 'accessToken': that.accessToken });
    },
    NowTime1() {
      var myDate = new Date();
      var y = myDate.getFullYear();
      var M = myDate.getMonth() + 1;     //获取当前月份(0-11,0代表1月)
      var d = myDate.getDate()-1;        //获取当前日(1-31)
      var h = '00';       //获取当前小时数(0-23)
      var m = '00';     //获取当前分钟数(0-59)
      var s = '00';     //获取当前秒数(0-59)

      //检查是否小于10
      M = this.check(M);
      d = this.check(d);
      // h = this.check(h);
      // m = this.check(m);
      // s = this.check(s);
      this.timestr = y + "-" + M + "-" + d + " " + h + ":" + m + ":" + s;
      // this.handleClick();
    },
     //刷新时间
    NowTime() {
      var myDate = new Date();
      var y = myDate.getFullYear();
      var M = myDate.getMonth() + 1;     //获取当前月份(0-11,0代表1月)
      var d = myDate.getDate();        //获取当前日(1-31)
      var h = myDate.getHours();       //获取当前小时数(0-23)
      var m = myDate.getMinutes();     //获取当前分钟数(0-59)
      var s = myDate.getSeconds();     //获取当前秒数(0-59)

      //检查是否小于10
      M = this.check(M);
      d = this.check(d);
      h = this.check(h);
      m = this.check(m);
      s = this.check(s);
      this.timestr = y + "-" + M + "-" + d + " " + h + ":" + m + ":" + s;
      // this.handleClick();
    },
    check(i) {
      var num = (i < 10) ? ("0" + i) : i;
      return num;
    },
    // 刷新数据
    getmpupdate() {
      // this.getinfoMethod();
      if(this.pagingData.article_list.length>0){
            this.timeshua =this.pagingData.article_list[0].postTime;
            this.hrefs = this.pagingData.article_list[0].articles[0].href;
          }else{
            // this.timestr = new Date()-24*3600*1000;
          };
      if(this.vip<=1){
        this.$my_message.install({
              text: '该功能仅限高级及以上会员使用！',
              type: "warning",
            });
            return
      };
      this.showk=true;
      this.time11 = this.timeshua.slice(0,10);
      var that = this;
      that.$http.axiosFun(that.$api.search.mp_update, {
        url:that.hrefs,
        time:that.time11,
      }, function (res) {
        if(res.code == 0){
          that.similarSearchss11();
          that.NowTime();
          that.$my_message.install({
            text: res.msg,
            type: 'warning'
          });
        that.inner = setInterval(that.timefun, 1000);
          // that.showk=false;
        }else if (res.code == 1) {
          that.NowTime();
          that.$my_message.install({
            text: res.msg,
            type: 'warning'
          });
          that.showk=false;
        } else {
          that.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      });
    },
    timefun() {
		this.t--;
		if(this.t <= 0) {
			this.showk=false;
      clearTimeout(this.inner);
      this.t = 5;
		}else{

    }
	},
    openMethod(e) {
      window.open(e);
    },
    opentitle(e) {
      window.open(e);
    },
    changeCloseMethod() {
      this.changeShow = false;
    },
    addShowMethod11() {
      this.addShow = true;
    },
    changeShowMethod11() {
      this.changeShow = true;
    },
    addCloseMethod1() {
      this.addShow = false;
    },
    addgroupMethods() {
      this.addgroupMethod();
    },
    //添加小组
    addgroupMethod() {
      var that = this;
      that.$http.axiosFun(
        that.$api.search.group_add,
        {
          name: that.gzgroupName,
        },
        function (res) {
          if (res.msg == "success") {
            that.addShow = false;
            that.groupList = res.data;
            Vue.set(that.groupList);
          } else {
            that.$my_message.install({
              text: res.msg,
              type: "warning",
            });
          }
        }
      );
    },
    //收藏小组列表
    getgroupList() {
      var that = this;
      that.$http.axiosFun(
        that.$api.search.group_list,
        {},
        function (res) {
          if (res.msg == "success") {
            that.groupList = res.data;
            Vue.set(that.groupList);
          } else {
          }
        },
        {
          "Content-Type": "application/x-www-form-urlencoded",
          accessToken: that.accessToken,
        }
      );
    },
    // 更改小程序分组名称
    changgroup(mp) {
      var that = this;
      that.$http.axiosFun(
        that.$api.search.group_rename,
        {
          group_id: that.groupid,
          name: that.groupName2,
        },
        function (res) {
          if (res.msg == "success") {
            that.getgroupList();
            that.changeShow = false;
            that.groupName2 = "";
          } else {
            that.$my_message.install({
              text: res.msg,
              type: "warning",
            });
          }
        }
      );
    },
    //删除小组
    deleteGroup(id) {
      var that = this;
      that.$http.axiosFun(
        that.$api.search.group_delete,
        {
          group_id: id,
        },
        function (res) {
          if (res.msg == "success") {
            that.getgroupList();
          } else {
            that.$my_message.install({
              text: res.msg,
              type: "warning",
            });
          }
        }
      );
    },

    collectedArrticle(articles) {
      this.articles_obj = articles;
      this.gzhaosc = true;
      // collect_group_list
      this.$http.axiosFun(
        this.$api.search.collect_group_list,
        {
          type: 1,
        },
        (res) => {
          if (res.error_code == 0) {
            this.groupList = res.data;
            this.is_collect = true;
            // console.log(this.groupList);
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 取消收藏
    cancelCollectAtricle(articles) {
      let that = this;
      // console.log(articles.aid, articles.mid)
      that.$http.axiosFun(
        that.$api.search.favorite_article_option2,
        {
          aid: articles.aid,
          mid: articles.mid,
        },
        function (res) {
          if (res.msg == "success") {
            that.is_collect = false;
            that.gzhaosc = false;
            that.$my_message.install({
              text: "取消收藏成功",
              type: "success",
            });
          } else {
            that.$my_message.install({
              text: res.msg,
              type: "warning",
            });
          }
        }
      );
    },
    // 添加收藏
    addArticleCollection(articles, groupid) {
      var that = this;
      // console.log(articles, groupid);
      if (groupid == "") {
        that.$my_message.install({
          text: "请选择你想要的组添加",
          type: "warning",
        });
      } else {
        that.$http.axiosFun(
          that.$api.search.favorite_article_option1,
          {
            aid: that.articles_obj.aid,
            group_id: groupid,
            mid: that.articles_obj.mid,
            wxname: that.articles_obj.mp_name,
          },
          function (res) {
            if (res.msg == "success") {
              that.getgroupList();
              that.gzhaosc = false;
              that.$my_message.install({
                text: "收藏成功",
                type: "success",
              });
            } else {
              that.$my_message.install({
                text: res.msg,
                type: "warning",
              });
            }
          }
        );
      }
    },
    ungroupShow1() {
      this.gzhaosc = !this.gzhaosc;
    },
    QRMouseenter() {
      this.QRVisible = true;
    },
    QRMouseleave() {
      this.QRVisible = false;
    },
    // 关联小程序
    relationSortClick(item, index) {
      this.relationSortNum2 = index;
      this.relationSortNum = index + 1;
      this.$http.axiosFun(
        this.$api.text.associatedapplet,
        {
          id: this.data.mid,
          orderby: this.relationSortNum,
          page: 1,
        },
        (res) => {
          if (res.status == 200) {
            // console.log(res);
            this.appletData = {
              applet_data: res.applet_data,
              VIPLimit: true,
            };
            // console.log(this.appletData);
          } else if (res.status == 4002) {
            this.appletData.VIPLimit = false;
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
      // console.log(index);
    },
    // 发文时间
    originClick(item, index) {
      this.originHrefVisible = false;
      this.originHrefNUm = index;
      // console.log(this.timeSort(index))
      switch (index) {
        case 0:
          this.timeSortNum = 1;
          break;
        case 1:
          this.timeSortNum = 7;
          break;
        case 2:
          this.timeSortNum = 30;
          break;
        case 3:
          this.timeSortNum = 60;
          break;
      }
      this.$http.axiosFun(
        this.$api.text.textlink,
        {
          id: this.data.mid,
          page: this.pageHref,
          pagesize: 10,
          days: this.timeSortNum,
          orderby: this.classSortNum,
        },
        (res) => {
          if (res.status == 200) {
            this.originHrefVisible = true;
            this.originHrefObject = {
              article_list: res.article_list,
              total_number: res.total_number,
              VIPLimit: true,
            };
            // console.log(this.originHrefObject);
          } else if (res.status == 40002) {
            this.originHrefObject.VIPLimit = false;
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
      // console.log(this.timeSortNum);
    },
    // 点赞数排序
    originClick2(item, index) {
      this.originHrefVisible = false;
      this.originHrefNUm2 = index;
      // console.log(this.timeSort(index))
      switch (index) {
        case 0:
          this.classSortNum = 1;
          break;
        case 1:
          this.classSortNum = 7;
          break;
        case 2:
          this.classSortNum = 30;
          break;
        case 3:
          this.classSortNum = 60;
          break;
      }
      this.$http.axiosFun(
        this.$api.text.textlink,
        {
          id: this.data.mid,
          page: this.pageHref,
          pagesize: 10,
          days: this.timeSortNum,
          orderby: this.classSortNum,
        },
        (res) => {
          if (res.status == 200) {
            this.originHrefVisible = true;
            this.originHrefObject = {
              article_list: res.article_list,
              total_number: res.total_number,
              VIPLimit: true,
            };
            // console.log(this.originHrefObject);
          } else if (res.status == 4002) {
            this.originHrefObject.VIPLimit = false;
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
      // console.log(this.timeSortNum);
    },
    // 同体公众号进入详情
    officialDetials(item, index) {
      // console.log(item);
      this.isDetailsShow = true;
      this.isVisible2 = true;
      this.loadingVisible2 = false;
      this.$http.axiosFun(
        this.$api.search.mp_detail,
        {
          mId: item.mid,
        },
        (res1) => {
          if (res1.error_code == 0) {
            // console.log(res1);
            // 监控数量 mpaccount
            this.$http.axiosFun(
              this.$api.mpaccount.monitor,
              {
                wxid: item.wxid,
              },
              (res) => {
                if (res.error_code == 200) {
                  // console.log(res)
                  this.loadingVisible2 = true;
                  this.officialDetailData = res1.data;
                  this.officialDetailData.monitor_num = res.data;
                  // console.log(this.detailData)
                }
              },
              {
                "Content-Type": "application/x-www-form-urlencoded",
                accessToken: this.accessToken,
              }
            );
            // 二维码
            this.$http.axiosFun(
              this.$api.search.detail_statistic,
              {
                mId: item.mid,
              },
              (res) => {
                if (res.error_code == 0) {
                  this.officialDetailData.QRavatar = res.data.avatar;
                  // console.log(this.officialDetailData);
                }
              },
              {
                accessToken: this.accessToken,
              }
            );
          }
        },
        {
          "Content-Type": "application/x-www-form-urlencoded",
          accessToken: this.accessToken,
        }
      );
      this.$http.axiosFun(
        this.$api.search.detail_pubList,
        {
          mId: item.mid,
          page: 1,
          num: 20,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible2 = true;
            this.pagingData = {
              article_list: res.data.article_list,
              total: res.data.total,
            };
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 同体公众号列表
    collectionSubjectClick(item, index) {
      // console.log(item);
    },
    // 主体信息点击展开
    subjectListClick() {
      this.subject1 =true;
    },
    // 公众号详情里面收藏
    collectionClick(data) {
      // console.log(data);
      this.managementVisible = true;
      // 加入收藏
      this.$http.axiosFun(
        this.$api.search.group_list_ext,
        {},
        (res) => {
          if (res.error_code == 0) {
            res.data.forEach((item) => {
              // console.log(item);
              item.checkAll = false;
              item.account_list.forEach((items) => {
                items.checked = false;
              });
            });
            this.manageData = {
              manageList: res.data,
              manageElement: data,
            };
            // console.log(this.manageData);
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
      // console.log(data);
    },
    // 公众号详情里面取消收藏
    cancelCollectionClick(data) {
      // console.log(data);
      // 取消收藏
      this.$http.axiosFun(
        this.$api.search.favorite_delete,
        {
          mid: data.mid,
        },
        (res) => {
          if (res.error_code == 0) {
            this.data.is_favorite = 0;
            this.$my_message.install({
              text: `取消关注成功`,
              type: "success",
            });
          }
        }
      );
    },
    // 组件回调的数据
    groupCallBack(data) {
      // console.log(data);
      data.is_favorite = 1;
      this.$http.axiosFun(
        this.$api.search.group_list_ext,
        {},
        (res) => {
          if (res.error_code == 0) {
            res.data.forEach((item) => {
              // console.log(item);
              item.checkAll = false;
              item.account_list.forEach((items) => {
                items.checked = false;
              });
            });
            this.manageData = {
              manageList: res.data,
              manageElement: data,
            };
            // console.log(this.manageData);
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 关闭公众号详情里面的分组管理
    closeManagementClick() {
      this.managementVisible = !this.managementVisible;
    },
    // 搜索enter事件
    similarKeyUp(e) {
      this.loadingVisible = false;
      this.similarKw = e.target.value;
      this.$http.axiosFun(
        this.$api.search.detail_pubList,
        {
          kw: this.similarKw,
          mId: this.data.mid,
          is_hot: this.is_hot,
          top: this.top,
          start_time: this.start_time,
          end_time: this.end_time,
          page: this.pageNum,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible = true;
            this.pagingData = {
              article_list: res.data.article_list,
              total: res.data.total,
            };
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 搜索文字
    similarSearchKw(e) {
      this.similarKw = e.target.value;
    },
    similarSearchss11() {
      this.loadingVisible = false;
      this.$http.axiosFun(
        this.$api.search.detail_pubList,
        {
          mId: this.data.mid,
          page: 1,
          num: 20,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible = true;
            this.pagingData = {
              article_list: res.data.article_list,
              total: res.data.total,
            };
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 通过点击进行搜索
    similarSearch() {
      this.loadingVisible = false;
      this.$http.axiosFun(
        this.$api.search.detail_pubList,
        {
          kw: this.similarKw,
          mId: this.data.mid,
          is_hot: this.is_hot,
          top: this.top,
          kw_type: this.screen,
          start_time: this.start_time,
          end_time: this.end_time,
          page: this.pageNum,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible = true;
            this.pagingData = {
              article_list: res.data.article_list,
              total: res.data.total,
            };
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 改变时间戳结构：xxxx-xx-xx
    changeTimeStructure(timeData) {
      let date = new Date(timeData);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      const time = y + "-" + m + "-" + d;
      return time;
    },
    // 时间段区间筛选
    pageTimeChange(val) {
      this.loadingVisible = false;
      if (val) {
        this.start_time = this.changeTimeStructure(val[0]);
        this.end_time = this.changeTimeStructure(val[1]);
      } else {
        this.start_time = null;
        this.end_time = null;
      }
      this.$http.axiosFun(
        this.$api.search.detail_pubList,
        {
          kw: this.similarKw,
          mId: this.data.mid,
          is_hot: this.is_hot,
          top: this.top,
          start_time: this.start_time,
          end_time: this.end_time,
          page: this.pageNum,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible = true;
            this.pagingData = {
              article_list: res.data.article_list,
              total: res.data.total,
            };
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 点击原文链接
    handleCurrentChange2(num) {
      this.originHrefVisible = false;
      this.pageHref = num;
      this.$http.axiosFun(
        this.$api.text.textlink,
        {
          id: this.data.mid,
          page: this.pageHref,
          pagesize: 10,
          days: this.timeSortNum,
          orderby: this.classSortNum,
        },
        (res) => {
          if (res.status == 200) {
            this.originHrefVisible = true;
            this.originHrefObject = {
              article_list: res.article_list,
              total_number: res.total_number,
              VIPLimit: true,
            };
            // console.log(this.originHrefObject);
          } else if (res.status == 4002) {
            this.originHrefObject.VIPLimit = false;
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 点击分页按钮请求数据
    handleCurrentChange(num) {
      this.pageNum = num;
      this.loadingVisible = false;
      this.$http.axiosFun(
        this.$api.search.detail_pubList,
        {
          kw: this.similarKw,
          mId: this.data.mid,
          is_hot: this.is_hot,
          top: this.top,
          start_time: this.start_time,
          end_time: this.end_time,
          page: this.pageNum,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible = true;
            this.pagingData = {
              article_list: res.data.article_list,
              total: res.data.total,
            };
            // console.log(res);
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
      // console.log(num);
    },
    analysisClick(item) {
      this.analysisVisible = true;
      // 监控报告
      this.$http.axiosFun(
        this.$api.mpaccount.monitor_list,
        {
          wxid: item.wx,
        },
        (res) => {
          if (res.error_code == 200) {
            this.analysisData = item;
            this.analysisData.analysisList = res.data;
            // console.log(res.data);
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 隐藏公众号详情
    unaccountPopup() {
      this.isVisible = false;
    },
    monitorCloseClick() {
      this.monitorVisible = !this.monitorVisible;
    },
    stopingCloseClick() {
      this.stopingVisible = !this.stopingVisible;
    },
    similarCloseClick() {
      this.similarVisible = !this.similarVisible;
    },
    analysisCloseClick() {
      this.analysisVisible = !this.analysisVisible;
    },
    // 获取相似文章数据
    lookDetails(data) {
      this.similarVisible = !this.similarVisible;
      this.$http.axiosFun(
        this.$api.search.mp_detail,
        {
          mId: data.mid,
        },
        (res) => {
          if (res.error_code == 0) {
            // console.log(res.data);
            this.data = res.data;
          }
        },
        {
          "Content-Type": "application/x-www-form-urlencoded",
          accessToken: this.accessToken,
        }
      );
      // console.log(data);
    },
    // 数据回采
    monitorShow(mpshuju) {
      // this.monitorVisible = true;
      this.$refs.monit.mId = mpshuju.mid;
      this.$refs.monit.avatar = mpshuju.avatar;
      this.$refs.monit.wx_id = mpshuju.wxid;
      this.$refs.monit.name1 = mpshuju.mp_name;
      this.$refs.monit.getmonito();
      this.$refs.monit.monito1();
    },
    stopingShow(mpshuju) {
      this.$refs.stop.mId = mpshuju.mid;
      this.$refs.stop.avatar = mpshuju.avatar;
      this.$refs.stop.wx_id = mpshuju.wxid;
      this.$refs.stop.name1 = mpshuju.mp_name;
      this.$refs.stop.getmid();
      this.$refs.stop.stoping1();
      // this.stopingVisible = true;
    },
    similarShow(datas) {
      this.loadingVisible2 = false;
      this.similarDataObject = {
        avatar: datas.avatar,
        area: datas.area,
        collect_count: datas.collect_count,
        dajiala_index: datas.dajiala_index,
        desc: datas.desc,
        group_age: datas.group_age,
        group_sex: datas.group_sex,
        have_owner: datas.have_owner,
        is_avatar: datas.is_avatar,
        is_favorite: datas.is_favorite,
        media: datas.media,
        mid: datas.mid,
        monitor_num: 0,
        mp_fetch_sum: datas.mp_fetch_sum,
        name: datas.name,
        owner: datas.owner,
        pubtime: datas.pubtime,
        reg_time: datas.reg_time,
        same_owner: datas.same_owner,
        tag: datas.tag,
        update_time: datas.update_time,
        wx: datas.wx,
        VIPLimit: true,
      };
      this.similarVisible = true;
      // 点击获取数据 mp_similar
      this.$http.axiosFun(
        this.$api.search.mp_similar,
        {
          mid: this.data.mid,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible2 = true;
            this.similarDataObject = {
              total: res.data.total,
              accounts: res.data.accounts,
              avatar: this.data.avatar,
              area: this.data.area,
              collect_count: this.data.collect_count,
              dajiala_index: this.data.dajiala_index,
              desc: this.data.desc,
              group_age: this.data.group_age,
              group_sex: this.data.group_sex,
              have_owner: this.data.have_owner,
              is_avatar: this.data.is_avatar,
              is_favorite: this.data.is_favorite,
              media: this.data.media,
              mid: this.data.mid,
              monitor_num: 0,
              mp_fetch_sum: this.data.mp_fetch_sum,
              name: this.data.name,
              owner: this.data.owner,
              pubtime: this.data.pubtime,
              reg_time: this.data.reg_time,
              same_owner: this.data.same_owner,
              tag: this.data.tag,
              update_time: this.data.update_time,
              wx: this.data.wx,
              VIPLimit: true,
            };
          } else if (res.error_code == 40002) {
            this.loadingVisible2 = true;
            this.similarDataObject.VIPLimit = false;
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    VIPLimit() {
      let routeData = this.$router.resolve({
        path: "/center",
        query: {
          tabSt: 2,
        },
      });
      window.open(routeData.href, "_blank");
    },
    closeClick() {
      this.popupItem = 0;
      this.subject1 = false;
      this.$emit("closeClick");
    },
    closeClick2() {
      this.isVisible2 = !this.isVisible2;
    },
    // 只显示头条
    isTop() {
      this.loadingVisible = false;
      if (this.valueTop) {
        this.top = 1;
      } else {
        this.top = 0;
      }
      this.$http.axiosFun(
        this.$api.search.detail_pubList,
        {
          mId: this.data.mid,
          top: this.top,
          start_time: this.start_time,
          end_time: this.end_time,
          is_hot: this.is_hot,
          page: this.pageNum,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible = true;
            this.pagingData = {
              article_list: res.data.article_list,
              total: res.data.total,
            };
            // console.log(res);
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 只显示爆文
    isExplosive() {
      this.loadingVisible = false;
      if (this.valueExplosive) {
        this.is_hot = 1;
      } else {
        this.is_hot = 0;
      }
      this.$http.axiosFun(
        this.$api.search.detail_pubList,
        {
          mId: this.data.mid,
          top: this.top,
          start_time: this.start_time,
          end_time: this.end_time,
          is_hot: this.is_hot,
          page: this.pageNum,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible = true;
            this.pagingData = {
              article_list: res.data.article_list,
              total: res.data.total,
            };
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    pagingMouseEnter(item, index) {
      this.pagingNum = index;
    },
    pagingMouseLeave(item, index) {
      this.pagingNum = null;
    },
    articlesMouseEnter(item, index) {
      this.favoriteNum = index;
      // console.log(index);
    },
    articlesMouseLeave(item, index) {
      this.favoriteNum = null;
      // console.log(index);
    },
    popupClick(item, index) {
      this.popupItem = index;
      switch (this.popupItem) {
        case 0:
          this.$http.axiosFun(
            this.$api.search.detail_pubList,
            {
              mId: this.data.mid,
              // page: 1,
              num: 20,
            },
            (res) => {
              if (res.error_code == 0) {
                this.pagingData = {
                  article_list: res.data.article_list,
                  total: res.data.total,
                };
                // console.log(res);
              }
            },
            {
              accessToken: this.accessToken,
            }
          );
          // console.log("aaa");
          break;
        case 1:
          this.$http.axiosFun(
            this.$api.search.detail_statistic,
            {
              mId: this.data.mid,
            },
            (res) => {
              if (res.error_code == 0) {
                this.analysis_info = {
                  articles: res.data.analysis_info.articles,
                  avg_other_read: res.data.analysis_info.avg_other_read,
                  avg_second_read: res.data.analysis_info.avg_second_read,
                  avg_top_read: res.data.analysis_info.avg_top_read,
                  fans: res.data.analysis_info.fans,
                  avatar: res.data.avatar,
                  read_overview: res.data.read_overview,
                  VIPLimit: true,
                };
              } else if (res.error_code == 40002) {
                this.analysis_info.VIPLimit = false;
                // console.log(this.analysis_info);
              }
            },
            {
              accessToken: this.accessToken,
            }
          );
          break;
        case 2:
          // 获取同体公众号
          this.$http.axiosFun(
            this.$api.search.detail_owner,
            {
              mId: this.data.mid,
            },
            (res) => {
              if (res.error_code == 0&&this.vip>=3) {
                this.subject_info2 = {
                  same_accounts: res.data.same_accounts,
                  VIPLimit: true,
                };
                // console.log(this.subject_info);
              } else if (res.error_code == 40002) {
                this.subject_info2.VIPLimit = false;
                //  console.log(this.analysis_info);
              }
            },
            {
              accessToken: this.accessToken,
            }
          );
          // 日常发文时段
          var that = this;
          that.$http.axiosFun(
            that.$api.search.public_time,
            {
              mid: this.data.mid,
            },
            function (res) {
              if (res.msg == "success") {
                var arr = [];
                for (var i in res.data) {
                  var json = {
                    num: res.data[i],
                    height: "height:" + res.data[i] + "px",
                  };
                  arr.push(json);
                }
                that.chartList = arr;
              } else {
                // that.$message({
                //   message: res.msg,
                //   type: 'warning'
                // });
              }
            },
            {
              accessToken: that.accessToken,
            }
          );
          break;
        case 3:
          this.originHrefVisible = false;
          this.$http.axiosFun(
            this.$api.text.textlink,
            {
              id: this.data.mid,
              page: this.pageHref,
              pagesize: 10,
              days: this.timeSortNum,
              orderby: 1,
            },
            (res) => {
              if (res.status == 200) {
                this.originHrefVisible = true;
                this.originHrefObject = {
                  article_list: res.article_list,
                  total_number: res.total_number,
                  VIPLimit: true,
                };
                // console.log(this.originHrefObject);
              } else if (res.status == 4002) {
                this.originHrefObject.VIPLimit = false;
              }
            },
            {
              accessToken: this.accessToken,
            }
          );
          break;
        case 4:
          this.$http.axiosFun(
            this.$api.text.associatedapplet,
            {
              id: this.data.mid,
              orderby: this.relationSortNum + 1,
              page: 1,
            },
            (res) => {
              if (res.status == 200) {
                // console.log(res);
                this.appletData = {
                  applet_data: res.applet_data,
                  VIPLimit: true,
                };
                // console.log(this.appletData);
              } else if (res.status == 4002) {
                this.appletData.VIPLimit = false;
              }
            },
            {
              accessToken: this.accessToken,
            }
          );
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-select{
  width: 200px !important;
  margin-top: 12px !important;
  margin-left: 33px !important;
}
.ccc {
  color: #ccc;
}
.newGroupBack {
  width: 100vw;
  height: 100vh;
  border: solid 1px;
  // background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 199;
  .newGroup {
    width: 500px;
    height: 250px;
    border-radius: 10px;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    .add_top {
      padding: 30px 0;
      .titTx {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        position: relative;
      }
      .close_img {
        width: 18px;
        height: 18px;
        position: absolute;
        top: 35px;
        right: 30px;
      }
    }
    .tit {
      font-size: 16px;
      font-weight: bold;
      margin-left: 30px;
    }
    .name_inp {
      width: 432px;
      height: 40px;
      border-radius: 5px;
      border: 2px solid #999999;
      margin-top: 10px;
      margin-left: 30px;
      padding-left: 10px;
    }
    .btn_box {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 30px;
      margin-top: 25px;
      .rgbtn {
        width: 220px;
        display: flex;
        justify-content: space-between;
        .close_btn {
          width: 90px;
          height: 30px;
          color: #cccccc;
          border: 2px solid #f5f5f5;
          text-align: center;
          line-height: 32px;
          font-size: 16px;
          border-radius: 5px;
          cursor: pointer;
        }
        .qr_btn {
          width: 90px;
          height: 30px;
          color: #fefefe;
          border: 2px solid #20a0ff;
          text-align: center;
          line-height: 32px;
          font-size: 16px;
          background: #20a0ff;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
}
// 公众号关注
.groupingBox {
  width: 100vw;
  height: 100vh;
  // background: rgba(0, 0, 0, 0.178);
  position: fixed;
  border: solid 1px;
  // box-shadow: 10px 10px 5px #888888;;
  top: 0;
  left: 0;
  z-index: 100;
  .grouping {
    width: 600px;
    height: 610px;
    background: #ffffff;
    border-radius: 10px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    .group_top {
      height: 100px;
      line-height: 100px;
      font-size: 21px;
      font-weight: bold;
      text-align: center;
      position: relative;
      border-bottom: 2px solid #f5f5f5;
      .close_img {
        position: absolute;
        width: 18px;
        height: 18px;
        right: 30px;
        top: 40px;
      }
    }
    .rollerBox {
      height: 400px;
      overflow: auto;
      .group {
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 30px;
        border-bottom: 2px solid #f5f5f5;
        .btns {
          display: flex;
          .delete_btn {
            width: 70px;
            height: 30px;
            text-align: center;
            margin-left: 10px;
            line-height: 33px;
            font-size: 14px;
            border-radius: 5px;
            border: 2px solid #f5f5f5;
            color: #666666;
            cursor: pointer;
          }
        }
      }
    }
    .btn_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 30px;
      margin-top: 25px;
      .addbtn {
        color: #20a0ff;
        font-size: 18px;
        margin-left: 12px;
        cursor: pointer;
      }
      .rgbtn {
        width: 220px;
        display: flex;
        justify-content: space-between;
        .close_btn {
          width: 90px;
          height: 30px;
          color: #cccccc;
          border: 2px solid #f5f5f5;
          text-align: center;
          line-height: 32px;
          font-size: 16px;
          border-radius: 5px;
          cursor: pointer;
        }
        .qr_btn {
          width: 90px;
          height: 30px;
          color: #fefefe;
          border: 2px solid #20a0ff;
          text-align: center;
          line-height: 32px;
          font-size: 16px;
          background: #20a0ff;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  border: none;
  background-color: #fff;
}
.popup_subject_infos_active2 {
  cursor: pointer;
  border-radius: 4px;
  margin-top: calc(50px / 2 - 30px / 2);
  margin-left: 10px;
  line-height: 32px;
  text-align: center;
  width: 140px;
  height: 30px;
  color: #fff;
  display: inline-block;
  background-color: #19acff;
}
// 分页默认样式
.el-pagination__total {
  font-size: 20px !important;
}
.el-pager li {
  font-size: 20px;
}
.number {
  font-size: 20px;
}
// 本地代码
.popup_page_VIPLimit {
  width: 100%;
  height: 300px;
  // border: solid 1px;
  font-size: 24px;
  line-height: 300px;
  text-align: center;
  cursor: pointer;
}
.active_color {
  color: #20a0ff;
  border-bottom: solid 4px #20a0ff;
}
.accountPopup {
  width: 100%;
  height: 100%;
  background-color: rgba(29, 29, 29, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  .popup_box {
    width: 1400px;
    // height: 1020px;
    height: 100%;
    background-color: #fff;
    margin-left: calc(100% / 2 - 1400px / 2);
    // margin-top: 2%;
    position: fixed;
  }
  .popup_box > h1 {
    width: 100%;
    height: 70px;
    box-sizing: border-box;
    // border: solid 1px;
    font-size: 26px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 600;
    line-height: 70px;
    text-align: center;
    color: #000000;
  }
    .tanc{
      width:200px;
      height: 50px;
      display: block;
      font-size: 22px;
      margin-top: 15px;
      text-align: center;
      line-height: 50px;
      color:#fff;
      font-weight: bold;
      margin-right: 150px;
      margin-top: -95px;
      float: right;
      border-radius: 10px;
      background: rgb(250, 171, 67);
      cursor: pointer;
    }
  .popup_box > img {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
  .detailOverFlow {
    // border: solid 1px;
    height: 84%;
    overflow-x: hidden;
    position: relative;
  }
  .detail {
    width: 90%;
    margin-left: calc(100% / 2 - 90% / 2);
    height: 130px;
    // border: solid 1px red;
    box-sizing: border-box;
  }
  .detail > img {
    float: left;
    width: 120px;
    height: 120px;
    border-radius: 100%;
    border: solid 1px #ccc;
  }
  .detail_center {
    float: left;
    width: 660px;
    height: 120px;
    // border: solid 1px;
    margin-left: 20px;
  }
  .detail_center_top {
    float: left;
    width: 100%;
    // border: solid 1px;
    height: 50px;
  }
  .detail_center_top > span:first-child {
    float: left;
    font-size: 26px;
    line-height: 50px;
    height: 50px;
    display: inline-block;
    color: #333333;
    font-weight: 700;
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // border: solid 1px;
    cursor: pointer;
    box-sizing: border-box;
  }
  .detail_center_top > img:nth-child(2) {
    width: 20px;
    height: 20px;
    display: inline-block;
    float: left;
    margin-top: calc(50px / 2 - 20px / 2);
    margin-left: 20px;
  }
  .QR_box {
    position: absolute;
    top: 50px;
    left: 260px;
    z-index: 12000;
    width: 160px;
    height: 160px;
    // height: auto;
    background-color: #fff;
    img {
      width: 100%;
    }
  }
  .detail_center_top_tijiao {
    height: 50px;
    display: inline-block;
    cursor: pointer;
    // border: solid 1px green;
    margin-left: 20px;
  }
  .detail_center_top_tijiao > img:first-child {
    width: 24px;
    height: 24px;
    display: inline-block;
    float: left;
    margin-top: calc(50px / 2 - 24px / 2);
  }
  .detail_center_top_tijiao > span:nth-child(2) {
    height: 50px;
    line-height: 50px;
    display: inline-block;
    // border: solid 1px;
    float: left;
    box-sizing: border-box;
    margin-left: 10px;
    color: #19acff;
  }
  .detail_center_top_tijiao > img:nth-child(3) {
    width: 20px;
    height: 20px;
    display: inline-block;
    float: left;
    margin-top: calc(50px / 2 - 20px / 2);
  }
  .detail_center_top_tijiao > img:last-child {
    width: 30px;
    height: 30px;
    float: left;
    margin-top: calc(50px / 2 - 30px / 2);
    margin-left: 30px;
    display: inline-block;
  }
  .detail_center_center {
    font-size: 20px;
    width: 100%;
    height: 30px;
    color: #999999;
    display: inline-block;
  }
  .detail_center_bottom {
    width: 100%;
    font-size: 20px;
    display: inline-block;
    color: #666666;
    margin-top: 6px;
  }
  .detail_right {
    float: right;
    width: 185px;
    height: 120px;
    // border: solid 1px;
    span {
      width:100%;
      height: 40px;
      display: inline-block;
      font-size: 28px;
      margin-top: 0px;
    }
  }
  .dec {
    width: 90%;
    // height: 20px;
    margin-left: calc(100% / 2 - 90% / 2);
    font-size: 18px;
    margin-top: 30px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
  }
  .industry {
    width: 90%;
    height: 20px;
    margin-left: calc(100% / 2 - 90% / 2);
    font-size: 18px;
    color: #333;
    margin-top: 20px;
    span:nth-child(2) {
      margin-left: 40px;
    }
  }
  .popup_class {
    cursor: pointer;
    width: 90%;
    height: 30px;
    margin-top: 20px;
    margin-left: calc(100% / 2 - 90% / 2);
  }
  .popup_class > span:first-child {
    margin-left: 0;
  }
  .popup_class > span {
    float: left;
    margin-left: 80px;
    img {
      width: 20px;
      height: 20px;
      margin-top: calc(30px / 2 - 20px / 2);
      display: inline-block;
      float: left;
    }
    span {
      box-sizing: border-box;
      float: left;
      line-height: 30px;
      height: 30px;
      display: inline-block;
      margin-left: 12px;
      color: #333;
      // border: solid 1px;
      font-size: 16px;
    }
  }
  .popup_page {
    width: 100%;
    // border: solid 1px;
    margin-top: 20px;
    .popup_page_title {
      box-sizing: border-box;
      width: 100%;
      height: 60px;
      background-color: #fafafa;
      .popupLeft {
        float: left;
        width: 55%;
        text-align: 60px;
        // margin-top: 20px;
        display: inline-block;
        height: 60px;
        
        .span{
          display: inline-block;
          height: 60px;
          text-align: center;
          // margin-top: -28px;
          line-height: 60px;
          font-size: 20px;
          cursor: pointer;
          
        }
        .span3{
          display: inline-block;
          height: 60px;
          text-align: center;
          // margin-top: -28px;
          line-height: 60px;
          font-size: 20px;
          cursor: pointer;
        }
        .span1{
          display: inline-block;
          height: 60px;
          text-align: center;
          // margin-top: -22px;
          margin-left:35px;
          line-height: 60px;
          font-size: 20px;
          cursor: pointer;
        }
      }
      .popupRight {
        float: left;
        margin-left: 0px;
        width: 15%;
        display: inline-block;
        height: 60px;
        color: #333333;
        line-height: 60px;
        font-size: 20px;
      }
      .rg_tab{
        display: flex;
        align-items: center;
        // margin-right: 10px;
        line-height: 60px;
        cursor: pointer;
        float:right;
        .time{
          font-size: 16px;
        }
        .update_img{
          width: 30px;
          margin-left: 10px;
          cursor: pointer;
        }
      }
      .rg_tabs1{
        display: flex;
        float:left;
        align-items: center;
        margin-right: 170px;
        cursor: pointer;
        opacity: 0.5;
        line-height: 60px;
        .time{
          font-size: 0.5vw;
        }
        .update_img{
          width: 30px;
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
  .popup_page_handle {
    width: 94%;
    margin-left: calc(100% / 2 - 94% / 2);
    // border: solid 1px;
    height: 70px;
    margin-top: 20px;
    .popupTip {
      width: 100%;
      height: 90px;
      text-align: center;
      line-height: 90px;
      font-size: 24px;
      color: red;
    }
    .popup_pageing {
      width: 100%;
      height: 40px;
      margin-top: -40px;
      border-bottom: solid 3px #3c3c3c;
      box-sizing: border-box;
      span {
        float: right;
        width: 140px;
        height: 40px;
        border-top-left-radius: 10%;
        border-top-right-radius: 10%;
        background-color: #f5f5f5;
        text-align: center;
        line-height: 40px;
        font-size: 18px;
        color: #999;
        margin-top: -3px;
        box-sizing: border-box;
      }
    }
    // 历史推文部分
    .popup_page_handlePaging::after {
      content: "";
      clear: both;
      display: block;
    }
    .popup_page_handlePaging {
      width: 100%;
      // border: solid 1px;
      .valueTop {
        // border: solid 1px;
        height: 70px;
        width: 180px;
        display: inline-block;
        float: left;
        box-sizing: border-box;
        .el-switch {
          height: 70px;
          // border: solid 1px;
          box-sizing: border-box;
        }
        span {
          line-height: 70px;
        }
      }
      .valueExplosive {
        // border: solid 1px;
        height: 70px;
        width: 180px;
        display: inline-block;
        float: left;
        box-sizing: border-box;
        .el-switch {
          height: 70px;
          // border: solid 1px;
          box-sizing: border-box;
        }
        span {
          line-height: 70px;
        }
      }
      .valueDate {
        // border: solid 1px;
        float: left;
        height: 70px;
        box-sizing: border-box;
        padding: 14px 0;
        .el-date-editor {
          margin-left: 0;
          width: 380px;
          display: inline-block;
          overflow: hidden;
          .el-range-input {
            margin-top: 0;
            height: 30px;
            display: inline-block;
          }
        }
      }
      .valueSearch {
        float: right;
        // border: solid 1px;
        height: 40px;
        margin-top: calc(70px / 2 - 46px / 2);
        input {
          height: 34px;
          text-indent: 0.5em;
          float: left;
          border: solid 1px #ccc;
        }
        div {
          height: 40px;
          background-color: #19acff;
          display: inline-block;
          width: 100px;
          cursor: pointer;
        }
        div > img {
          float: left;
          width: 24px;
          margin-top: calc(40px / 2 - 24px / 2);
          margin-left: 18px;
        }
        div > span {
          float: left;
          height: 40px;
          line-height: 42px;
          color: #fff;
          margin-left: 6px;
        }
      }
       .hq{
        height:60px;
        line-height: 60px;
        font-size: 20px;
       .hqspan{
         width: 380px;
         margin-left: -730px;
         height:60px;
        //  border: 1px solid #ccc;
         display: block;
         float:left;
       } 
       .sx{
         display: block;
         width: 150px;
         height:40px;
         margin-top: 10px;
         color:#fff;
         float: right;
         border-radius: 5px;
         text-align: center;
         line-height: 40px;
         background: #20A0FF;
         cursor: pointer;
       }
      }
      .paging {
        width: 96%;
        overflow-x: hidden;
        height: 460px;
        margin-left: calc(100% / 2 - 96% / 2);
        // border: solid 1px #f1f1f1;
        float: left;
      }
      .paging > div {
        cursor: pointer;
        .paging_title {
          width: 100%;
          height: 50px;
          background: #e5e5e5;
          font-size: 16px;
          display: flex;
          justify-content: space-around;
          line-height: 50px;
        }
        .paging_title > span:first-child {
          padding: 0 10px;
          width: 38%;
          height: 50px;
          float: left;
          display: inline-block;
        }
        .paging_title > span:last-child {
          width: calc(100% - 38%);
          display: flex;
          justify-content: space-around;
          span > :first-child,
          span > :nth-child(2) {
            display: inline-block;
            line-height: 50px;
            width: calc(100% / 3);
            height: 50px;
            box-sizing: border-box;
            text-align: center;
          }
        }
        .paging_content {
          width: 100%;
          height: 50px;
          font-size: 20px;
        }
        .paging_content > span:first-child{
          padding: 0 10px;
          width: 38%;
          height: 100%;
          float: left;
          line-height: 50px;
          display: inline-block;
        }
        .paging_content > span:first-child::after {
          content: "";
          clear: both;
          display: block;
        }
        .sspp{
          // border: solid 1px green;
          width: 50px;
          height: 30px;
          background-color: rgb(254, 187, 2);
          float: left;
          box-sizing: border-box;
          display: inline-block;
          // height: 50px;
          text-align: center;
          line-height: 30px;
          color: #fff;
          border-radius: 8px;
          margin-top: calc(50px / 2 - 50px / 2);
          font-size: 14px;
        }
        .sspp1{
          // border: solid 1px green;
          width: 50px;
          height: 60px;
          // background-color: rgb(254, 187, 2);
          float: left;
          box-sizing: border-box;
          display: inline-block;
          // height: 50px;
          text-align: center;
          line-height: 30px;
          color: #fff;
          border-radius: 8px;
          margin-top: calc(50px / 2 - 30px / 2);
          font-size: 16px;
        }
        .spank1 {
          // border: solid 1px green;
          width: 50px;
          height: 20px;
          background-color: rgb(254, 187, 2);
          float: left;
          box-sizing: border-box;
          display: inline-block;
          // height: 50px;
          text-align: center;
          line-height: 20px;
          color: #fff;
          border-radius: 8px;
          // margin-top: calc(50px / 2 - 30px / 2);
          margin-top: -7px;
          font-size: 12px;
        }
        .span1 {
          // border: solid 1px green;
          width: 50px;
          height: 20px;
          background-color: #1f7500;
          float: left;
          box-sizing: border-box;
          display: inline-block;
          // height: 50px;
          text-align: center;
          line-height: 20px;
          color: #fff;
          border-radius: 8px;
          // margin-top: calc(50px / 2 - 30px / 2);
          margin-top: 5px;
          font-size: 12px;
        }
        // .paging_content > span:first-child > span:first-child,
        // .paging_content > span:first-child > span:nth-child(2) {
        //     display: inline-block;
        //     line-height: 50px;
        //     width: calc(100% / 3);
        //     height: 50px;
        //     box-sizing: border-box;
        //     text-align: center;
        //   }
        .paging_content > span:first-child > span:last-child {
          // border: solid 1px green;
          width: calc(100% - 90px);
          box-sizing: border-box;
          float: left;
          text-indent: 0.5em;
          display: inline-block;
          height: 50px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .paging_content > span:nth-child(2) {
          display: flex;
          justify-content: space-around;
        }

        .paging_content > span:nth-child(2) > span {
          // line-height: 50px;
          // width: calc(100% - 38%);
          // height: 50px;
          // text-align: center;
          display: inline-block;
            // border: solid 1px;
            line-height: 50px;
            width: calc( 100% / 1.8 );
            height: 50px;
            box-sizing: border-box;
            text-align: center;
        }
        .paging_content > span:nth-child(2) > span:first-child,
        .paging_content > span:nth-child(2) > span:nth-child(2) {
            display: inline-block;
            // border: solid 1px;
            line-height: 50px;
            width: 100%;
            height: 50px;
            box-sizing: border-box;
            text-align: center;
          }
        .paging_content > span:nth-child(2) > .favorite {
          position: relative;
          .favorite_span {
            left: 0;
            top: 0;
            width: 0%;
            color: #fff;
            overflow-y: hidden;
            height: 50px;
            background-color: #19acff;
            position: absolute;
          }
          .favorite_active {
            left: 0;
            top: 0;
            transition: 500ms;
            width: 100%;
            color: #fff;
            overflow-y: hidden;
            height: 50px;
            background-color: #19acff;
            position: absolute;
          }
        }
      }
      .paging_bottom {
        margin-left: calc(100% / 2 - 96% / 2);
        width: 96%;
        margin-top: 30px;
        float: left;
      }
    }
    // 基础分析部分
    .popup_page_detailStatistic::after {
      content: "";
      clear: both;
      display: block;
    }
    .popup_page_detailStatistic {
      width: 100%;
      margin-top: 50px;
      // border: solid 1px;
      .popup_page_detailStatistic_title {
        font-weight: 600;
        span {
          float: left;
          width: calc(100% / 5);
          display: inline-block;
          // border: solid 1px;
          height: 40px;
          font-size: 16px;
          line-height: 40px;
          text-align: center;
        }
      }
      .popup_page_detailStatistic_content {
        span {
          float: left;
          width: calc(100% / 5);
          display: inline-block;
          // border: solid 1px;
          height: 70px;
          font-size: 16px;
          line-height: 40px;
          text-align: center;
        }
      }
    }
    .popup_page_detailDetial::after {
      content: "";
      clear: both;
      display: block;
    }
    .popup_page_detailDetial {
      width: 100%;
      // border: solid 1px;
      margin-top: 20px;
      box-sizing: border-box;
      .popup_page_detailDetial_left::after {
        content: "";
        clear: both;
        display: block;
      }
      .popup_page_detailDetial_left {
        box-sizing: border-box;
        float: left;
        border: solid 1px #ccc;
        border-bottom: none;
        width: 80%;
        // height: 160px;
        .detailDetial_left_title {
          width: 100%;
          height: 50px;
          box-sizing: border-box;
          display: inline-block;
          font-size: 20px;
          padding-left: 54px;
          line-height: 50px;
          margin-top: 10px;
        }
        .popup_page_detailDetial_left::after {
          content: "";
          clear: both;
          display: block;
        }
        .detailDetial_left_top {
          font-size: 18px;
          span {
            width: calc(100% / 6);
            height: 56px;
            display: inline-block;
            border: solid 1px #ccc;
            border-left: none;
            border-right: none;
            box-sizing: border-box;
            float: left;
            text-align: center;
            line-height: 56px;
          }
        }
        .detailDetial_left_content {
          font-size: 18px;
          span {
            width: calc(100% / 6);
            height: 56px;
            display: inline-block;
            border: solid 1px #ccc;
            border-left: none;
            border-right: none;
            border-top: none;
            box-sizing: border-box;
            float: left;
            text-align: center;
            line-height: 56px;
          }
        }
      }
      .popup_page_detailDetial_right {
        box-sizing: border-box;
        float: left;
        border: solid 1px #ccc;
        border-left: none;
        width: calc(20%);
        height: 100%;
        padding-bottom: 56px;
        img {
          width: 80%;
          margin-top: 40px;
          display: inline-block;
          margin-left: calc(100% / 2 - 80% / 2);
        }
        span {
          width: 100%;
          height: 30px;
          font-size: 20px;
          text-align: center;
          line-height: 30px;
          display: inline-block;
          // border: solid 1px;
        }
      }
    }
    // 主体信息
    .popup_subject_info::after {
      content: "";
      clear: both;
      display: block;
    }
    .popup_subject_info {
      width: 100%;
      // border: solid 1px;
      margin-top: 40px;
      height: auto;
      box-sizing: border-box;
      .popup_subject_infos::after {
        content: "";
        clear: both;
        display: inline-block;
      }
      .popup_subject_infos {
        // border: solid 1px;
        display: inline-block;
        width: 100%;
        height: 50px;
        .popup_subject_infos_title {
          font-size: 20px;
          line-height: 50px;
          font-weight: 600;
          float: left;
        }
        .popup_subject_infos_active {
          cursor: pointer;
          border-radius: 4px;
          margin-top: calc(50px / 2 - 30px / 2);
          margin-left: 10px;
          line-height: 34px;
          text-align: center;
          color: #fff;
          width: 80px;
          height: 30px;
          display: inline-block;
          background-color: #19acff;
        }
        .popup_subject_infos_list {
          display: inline-block;
          width: auto;
          float: left;
          box-sizing: border-box;
          height: 50px;
          // border: solid 1px #999;
        }
        .popup_subject_infos_list > span {
          cursor: pointer;
          border-radius: 4px;
          margin-top: calc(50px / 2 - 30px / 2);
          margin-left: 10px;
          line-height: 32px;
          text-align: center;
          width: 80px;
          height: 30px;
          display: inline-block;
          border: solid 1px #999;
        }
      }
      .popup_subject_relation {
        display: inline-block;
        width: 100%;
        height: 50px;
        // border: solid 1px;
        .popup_subject_relation_title {
          display: inline-block;
          width: auto;
          float: left;
          line-height: 50px;
          box-sizing: border-box;
          height: 50px;
          // border: solid 1px #999;
        }
        .popup_subject_relation_list > span {
          cursor: pointer;
          border-radius: 4px;
          margin-top: calc(50px / 2 - 30px / 2);
          margin-left: 10px;
          line-height: 32px;
          text-align: center;
          width: 140px;
          height: 30px;
          display: inline-block;
          border: solid 1px #999;
        }
      }
      .popup_subject_applet_data {
        display: inline-block;
        width: 95%;
        height: 300px;
        margin-left: calc(100% / 2 - 95% / 2);
        // border-radius: 8px;
        margin-top: 30px;
        // padding: 10px 30px;
        // box-sizing: border-box;
        // border: solid 1px #ccc;
        .popup_subject_applet_dataList {
          box-sizing: border-box;
          border-radius: 8px;
          padding: 20px 30px;
          border: solid 1px #ccc;
          float: left;
          width: 100%;
          margin-top: 20px;
          // height: 280px;
          height: auto;
          box-sizing: border-box;
          display: inline-block;
          .popup_subject_dataList_top::after {
            content: "";
            clear: both;
            display: inline-block;
          }
          .popup_subject_dataList_top {
            border: solid 1px #ccc;
            border-top: none;
            border-left: none;
            border-right: none;
            height: 160px;
            width: 100%;
            box-sizing: border-box;
            .popup_subject_dataList_img {
              float: left;
              width: 120px;
              height: 120px;
              border-radius: 100%;
              border: solid 1px #ccc;
              display: inline-block;
              margin-top: calc(140px / 2 - 120px / 2);
            }
            .popup_subject_dataList_topRight {
              // border: solid 1px;
              height: 140px;
              margin-left: 20px;
              box-sizing: border-box;
              float: left;
              width: calc(100% - 150px);
            }
            .popup_subject_dataList_topRight > span:first-child {
              width: 100%;
              height: 40px;
              display: inline-block;
              // border: solid 1px;
              font-size: 24px;
              line-height: 40px;
              span:first-child {
                font-weight: 600;
              }
              span:nth-child(2) {
                font-size: 16px;
                margin-left: 10px;
                color: #999;
              }
            }
            .popup_subject_dataList_topRight > span:nth-child(2) {
              width: 100%;
              height: 40px;
              display: inline-block;
              // border: solid 1px;
              font-size: 18px;
              color: #999;
              line-height: 40px;
              span:nth-child(2) {
                margin-left: 20px;
              }
            }
            .popup_subject_dataList_topRight > span:nth-child(3) {
              width: 100%;
              height: 50px;
              display: inline-block;
              // border: solid 1px;
              font-size: 16px;
              color: #666;
              display: -webkit-box;
              overflow: hidden;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              // line-height: 40px;
            }
          }
          .popup_subject_dataList_bottom::after {
            content: "";
            display: inline-block;
            clear: both;
          }
          .popup_subject_dataList_bottom {
            height: 100px;
            margin-top: 20px;
            // border: solid 1px;
            width: 100%;
            padding-bottom: 10px;
            box-sizing: border-box;
          }
          .popup_subject_dataList_bottom > span {
            float: left;
            width: calc(100% / 3);
            height: 80px;
            display: inline-block;
            // border: solid 1px;
            margin-top: calc(100px / 2 - 80px / 2);
            box-sizing: border-box;
            span:first-child {
              font-size: 20px;
              font-weight: 600;
            }
            span {
              // border: solid 1px;
              font-size: 20px;
              text-align: center;
              line-height: 40px;
              width: 100%;
              height: 40px;
              display: inline-block;
              box-sizing: border-box;
            }
          }
        }
      }
      .popup_subject_originList {
        // border: solid 1px;
        display: inline-block;
        width: 100%;
      }
      .popup_subject_originTitle {
        margin-top: 20px;
        width: 100%;
        height: 50px;
        background-color: #f1f1f1;
        display: inline-block;
      }
      .popup_subject_originTitle::after {
        content: "";
        clear: both;
        display: inline-block;
      }
      .popup_subject_originTitle > span:first-child {
        width: calc(100% / 2.93);
        // span {
        //   display: inline-block;
        //   width: 90px;
        //   height: 30px;
        //   background-color: #ff8700;
        // }
      }
      .popup_subject_originTitle > span:nth-child(2) {
        width: calc(100% / 6);
      }
      .popup_subject_originTitle > span:nth-child(3) {
        width: calc(100% / 6);
      }
      .popup_subject_originTitle > span:nth-child(4) {
        width: calc(100% / 8);
      }
      .popup_subject_originTitle > span:nth-child(5) {
        width: calc(100% / 10);
      }
      .popup_subject_originTitle > span:nth-child(6) {
        width: calc(100% / 10);
      }
      .popup_subject_originTitle > span {
        height: 50px;
        font-size: 20px;
        text-align: center;
        line-height: 50px;
        // width: calc(100% / 6);
        float: left;
        display: inline-block;
        // border: solid 1px;
        box-sizing: border-box;
      }
      .popup_subject_originSome {
        // border: solid 1px #ccc;
        border-bottom: none;
        display: inline-block;
        width: 100%;
        .popup_subject_originSomeSpan {
          width: 100%;
          display: inline-block;
          height: 50px;
        }
        .popup_subject_originSomeSpan::after {
          content: "";
          clear: both;
          display: inline-block;
        }
        .popup_subject_originSomeSpan > span {
          border: solid 1px #ccc;
          border-top: none;
          border-left: none;
          border-right: none;
          box-sizing: border-box;
          display: inline-block;
          height: 50px;
          font-size: 16px;
          line-height: 50px;
          text-align: center;
          float: left;
        }
        .popup_subject_originSomeSpan > span:first-child {
          width: calc(100% / 2.93);
          white-space: nowrap;
          overflow: hidden;
          text-align: center;
          text-align: left;
          text-overflow: ellipsis;
        }
        .popup_subject_originSomeSpan > span:first-child > span:first-child {
          display: inline-block;
          width: 60px;
          height: 30px;
          border-radius: 4px;
          margin-top: calc(50px / 2 - 30px / 2);
          text-align: center;
          line-height: 30px;
          color: #fff;
          margin-left: 10px;
          background-color: #ff8700;
        }
        .popup_subject_originSomeSpan > span:first-child > span:last-child {
          margin-left: 10px;
        }
        .popup_subject_originSomeSpan > span:nth-child(2) {
          width: calc(100% / 6);
        }
        .popup_subject_originSomeSpan > span:nth-child(3) {
          width: calc(100% / 6);
          // font-size: 16px;
        }
        .popup_subject_originSomeSpan > span:nth-child(4) {
          width: calc(100% / 8);
        }
        .popup_subject_originSomeSpan > span:nth-child(5) {
          width: calc(100% / 10);
        }
        .popup_subject_originSomeSpan > span:nth-child(6) {
          width: calc(100% / 10);
          cursor: pointer;
          a {
            color: #20a0ff;
          }
        }
      }
      .subject_title {
        width: 100%;
        // border: solid 1px;
        height: 50px;
        float: left;
        img:first-child {
          width: 14px;
          height: 28px;
          display: inline-block;
          margin-top: calc(50px / 2 - 20px / 2);
        }
        span:nth-child(2) {
          margin-left: 10px;
          font-size: 20px;
        }
        span:nth-child(3) {
          margin-left: 100px;
          font-size: 20px;
        }
      }
      .chart_box {
        .chart {
          width: 1100px;
          min-height: 300px;
          margin: 17px auto;
          border-bottom: 3px solid #20a0ff;
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          .numdata {
            width: 15px;
            text-align: center;
            margin-bottom: -1px;
            .num {
              //margin-left: -6px;
              margin-bottom: 20px;
              color: #999999;
            }
            .sj_z {
              //width: 3px;
              background: #20a0ff;
              position: relative;
              margin: auto;
            }
            .num_act:after {
              content: "";
              display: block;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: #20a0ff;
              position: absolute;
              top: 0;
              margin-left: -2.7px;
              margin-top: -8px;
            }
          }
        }
        .chart_date {
          width: 1100px;
          margin: auto;
          display: flex;
          justify-content: space-between;
          .number {
            width: 15px;
            text-align: center;
          }
        }
      }
      .chart_box,
      .subject_content {
        width: 100%;
        // border: solid 1px pink;
        float: left;
        box-sizing: border-box;
        .subject_content_title {
          height: 50px;
          display: inline-block;
          width: 100%;
          float: left;
          margin-top: 20px;
          img:first-child {
            float: left;
            width: 14px;
            height: 28px;
            display: inline-block;
            margin-top: calc(50px / 2 - 20px / 2);
          }
          span:nth-child(2) {
            float: left;
            margin-left: 10px;
            font-size: 20px;
            line-height: 75px;
          }
          span:nth-child(3) {
            cursor: pointer;
            box-sizing: border-box;
            display: inline-block;
            float: right;
            // width: 210px;
            height: 50px;
            background: #20a0ff;
            border-radius: 2px;
            font-size: 18px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            padding-left: 5px;
            margin-right: 30px;
          }
        }
        .subject_content_list {
          width: 100%;
          height: 240px;
          overflow-x: hidden;
          display: inline-block;
          margin-top: 20px;
          .subject_content_some {
            width: 90%;
            height: 80px;
            cursor: pointer;
            display: inline-block;
            margin-left: calc(100% / 2 - 90% / 2);
            .common_subject::after {
              content: "";
              display: inline-block;
              clear: both;
            }
            .common_subject {
              width: 100%;
              .common_subject_img {
                width: 61px;
                height: 61px;
                border-radius: 100%;
                border: solid 1px #ccc;
                display: inline-block;
                float: left;
                margin-top: calc(80px / 2 - 61px / 2);
              }
              .common_subject_span1 {
                float: left;
                margin-left: 10px;
                margin-top: 10px;
                // border: solid 1px;
                display: inline-block;
                width: 200px;
                height: 30px;
                margin-top: calc(80px / 2 - 30px / 2);
              }
              .common_subject_img2 {
                float: left;
                margin-left: 10px;
                margin-top: 10px;
                display: inline-block;
                width: 700px;
                height: 61px;
                cursor: pointer;
                img:first-child {
                  margin-left: 0;
                }
                img {
                  display: inline-block;
                  width: 30px;
                  height: 30px;
                  margin-left: 20px;
                  margin-top: calc(61px / 2 - 30px / 2);
                }
              }
            }
          }
        }
        .subject_content_list1 {
          width: 100%;
          // height: 240px;
          overflow-x: hidden;
          display: inline-block;
          margin-top: 20px;
          .subject_content_some {
            width: 90%;
            height: 80px;
            cursor: pointer;
            display: inline-block;
            margin-left: calc(100% / 2 - 90% / 2);
            .common_subject::after {
              content: "";
              display: inline-block;
              clear: both;
            }
            .common_subject {
              width: 100%;
              .common_subject_img {
                width: 61px;
                height: 61px;
                border-radius: 100%;
                border: solid 1px #ccc;
                display: inline-block;
                float: left;
                margin-top: calc(80px / 2 - 61px / 2);
              }
              .common_subject_span1 {
                float: left;
                margin-left: 10px;
                margin-top: 10px;
                // border: solid 1px;
                display: inline-block;
                width: 200px;
                height: 30px;
                margin-top: calc(80px / 2 - 30px / 2);
              }
              .common_subject_img2 {
                float: left;
                margin-left: 10px;
                margin-top: 10px;
                display: inline-block;
                width: 700px;
                height: 61px;
                cursor: pointer;
                img:first-child {
                  margin-left: 0;
                }
                img {
                  display: inline-block;
                  width: 30px;
                  height: 30px;
                  margin-left: 20px;
                  margin-top: calc(61px / 2 - 30px / 2);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/searchPopup/official-account-popup.vue